import { render } from "./ContentsCard.vue?vue&type=template&id=3f2841ec&scoped=true"
import script from "./ContentsCard.vue?vue&type=script&lang=js"
export * from "./ContentsCard.vue?vue&type=script&lang=js"

import "./ContentsCard.vue?vue&type=style&index=0&id=3f2841ec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2841ec"]])

export default __exports__